import { Checkbox as AntDCheckbox, Form } from 'antd'
import { useField } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'

const { Item } = Form

export default function Checkbox({ containerClassName, label, ...rest }) {
  const [field, meta] = useField({ ...rest, type: 'checkbox' })
  const hasError = Boolean(meta.touched && meta.error)

  return (
    <Item
      className={containerClassName}
      hasFeedback={hasError}
      validateStatus={hasError ? 'error' : ''}
      help={hasError && meta.error}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <AntDCheckbox {...field} {...rest} value={field?.value || ''}>
        {label}
      </AntDCheckbox>
    </Item>
  )
}

Checkbox.propTypes = {
  containerClassName: PropTypes.string,
  label: PropTypes.string,
}

Checkbox.defaultProps = {
  containerClassName: undefined,
  label: '',
}
